/* eslint-disable react/style-prop-object */
import React, { Fragment } from 'react';
import { defaultFormat } from '../../../Utils/DateFormat';
import { numberFormat, formatPrice } from '../../../Utils/Common';
import Pagination from 'react-js-pagination';
import DynamicFont from 'react-dynamic-font';
import { Link } from 'react-router-dom';
import '../../layouts/template_styles/mototruck.css';
import moment from 'moment';
import { INVOICE_GET_SO } from './../../../redux/types';

export class ChargedSalesInvoice extends React.PureComponent {
    // function SalesInvoicePrintContent({ invoice, auth }) {
    // let subId = auth.user.subscriber_id;
    constructor(props) {
        super(props);
        this.divScrollRef = React.createRef();

        let img_url = '/app-assets/images/logo/sample-logo.png';
        const tableRows = this.renderExtrRow(this.props.print_rows);
        let totalItemsCount = this.props.invoice.invoice_items.length;
        this.state = {
            invoice: this.props.invoice,
            auth: this.props.auth,
            activePage: 1,
            itemsCountPerPage: 15,
            totalItemsCount: totalItemsCount,
            pageRangeDisplayed: 5,
            img_url: img_url,
            tableRows: tableRows,
            print: this.props.print,
            subs_setting: this.props.subs_setting,
        };
    }

    renderExtrRow(numberOfRows) {
        const tableRows = [];
        for (var i = 0; i < numberOfRows; i++) {
            tableRows.push(
                <tr key={'tr-' + i}>
                    <td>&nbsp;</td>
                    <td>&nbsp;</td>
                    <td>&nbsp;</td>
                    <td>&nbsp;</td>
                    <td>&nbsp;</td>
                    <td>&nbsp;</td>
                </tr>
            );
        }

        return tableRows;
    }

    handlePageChange(pageNumber) {
        this.setState({ activePage: pageNumber });
        this.divScrollRef.current.scrollIntoView();
    }

    renderPrint(page, totalPage) {
        // console.log(page, totalPage);
        const { invoice } = this.state;
        const totalItemsCount = invoice.invoice_items.length;
        var showItemsTo = page * this.state.itemsCountPerPage;
        var showItemsFrom = showItemsTo - this.state.itemsCountPerPage;
        showItemsTo = showItemsTo - 1;
        let extraRowsCount = this.state.itemsCountPerPage;
        if (this.state.print == 0) {
            // extraRowsCount -= 15;
        }

        invoice.invoice_items.map((item, i) => {
            if (showItemsFrom <= i && showItemsTo >= i) {
                extraRowsCount--;
                // console.log(extraRowsCount);
            }
        });

        // console.log(showItemsFrom, showItemsTo);
        // console.log(extraRowsCount);

        const DynamicStringStyle = {
            maxWidth: '150px',
            fontSize: '1rem',
            lineHeight: '1.45',
            overflow: 'hidden',
        };

        const itemProductNameStyle = {
            textAlign: 'left',
            padding: '0.5rem',
            verticalAlign: 'top',
            whiteSpace: 'normal',
            wordWrap: 'break-word',
            fontSize: '12px',
            lineHeight: '1',
        };

        const itemValueStyle = {
            textAlign: 'left',
            padding: '0.5rem',
            verticalAlign: 'top',
            fontSize: '12px',
        };

        const invoiceUnderlineStyle = {
            borderBottom: '1px solid #000',
            minHeight: '1.2em',
            display: 'inline-block',
            verticalAlign: 'bottom',
            width: '100%',
            padding: '0 4px',
            minWidth: '150px',
        };

        let auth = this.state.auth;

        let subId = '5fbce7782151301e660fa0d4';

        let img_url =
            auth.user.subscriber_id == subId
                ? '/monaki.png'
                : '/app-assets/images/logo/sample-logo.png';
        let company =
            auth.user.subscriber_id == subId ? 'Monikki Enterprises' : '';
        let address =
            auth.user.subscriber_id == subId
                ? '7i Bellagio 3 Forbestown Rd cor Burgos Circle BGC Taguig'
                : '';
        let contact = auth.user.subscriber_id == subId ? '02-7368-2071' : '';
        let email =
            auth.user.subscriber_id == subId
                ? 'mysecret.ph23@gmail.com.com'
                : '';
        let img_class =
            auth.user.subscriber_id == subId
                ? 'print-logo temp-logo'
                : 'print-logo';
        let temp_footer =
            auth.user.subscriber_id == subId ? (
                <div className="col-md-12">
                    <div className="f-14b temp-div pt-1 pb-2">
                        <div className="f-12">
                            {company} | {address} | {contact} | {email}{' '}
                        </div>
                    </div>
                </div>
            ) : (
                <div className="col-md-6 col-print-6">
                    <ul className="f-16b ul-print-paw">
                        <li>Phone #</li>
                        <li>Address</li>
                        <li>Webinvoicete</li>
                    </ul>
                </div>
            );

        const customerAddress = [
            invoice.customer.street1,
            invoice.customer.street2 && ', ',
            invoice.customer.street2,
            (invoice.customer.street1 || invoice.customer.street2) && ', ',
            invoice.customer.city,
            invoice.customer.city && invoice.customer.state && ', ',
            invoice.customer.state,
        ]
            .filter(Boolean)
            .join('');

        // const { company_name, company_address, company_landline, company_email } = this.state.subs_setting;
        const subs_setting = this.state.subs_setting;

        const currencyDisplay =
            subs_setting &&
            subs_setting.currency &&
            subs_setting.currency.code &&
            subs_setting.currency.code.checked
                ? 'code'
                : 'symbol';

        const template_setting = this.state.invoice.template_setting;

        return (
            <div
                className="receipt-container margin-1p5em px-1 print-page mt-1"
                style={{ fontFamily: '"Courier New", Courier, monospace' }}
            >
                <div className="print-logo-container print-header-container">
                    <div className="d-flex col-md-12 p-0 mb-2 align-items-center">
                        <div className="col-md-4 p-0">
                            <img
                                src={
                                    template_setting &&
                                    'company_logo' in template_setting
                                        ? template_setting.company_logo
                                        : '/BlitzLogo.png'
                                }
                                alt="logo"
                                className="print-logo"
                            />
                        </div>

                        <div
                            className="col-md-8 text-right text-black"
                            style={{ lineHeight: '1.2' }}
                        >
                            <div className="f-18b">
                                {template_setting && (
                                    <span>{template_setting.company_name}</span>
                                )}
                            </div>

                            <div className="f-10b">
                                {template_setting && (
                                    <span>
                                        {template_setting.company_address}
                                    </span>
                                )}
                            </div>
                        </div>
                    </div>

                    <div className="d-flex justify-content-between f-20b">
                        <div>CHARGED SALES INVOICE</div>
                        <div className="text-danger">
                            INVOICE NO.: {invoice.invoice_no}{' '}
                        </div>
                    </div>
                </div>

                <div className="print-body print-content-block">
                    {/* header */}
                    <div
                        className="invoice-fields f-10"
                        style={{ marginBottom: '1rem' }}
                    >
                        <div className="d-flex justify-content-between mb-1">
                            <div className="col-md-6 d-flex">
                                <div
                                    className="me-2 f-12b"
                                    style={{ minWidth: '110px' }}
                                >
                                    <strong>Sold to:</strong>
                                </div>
                                <div
                                    style={invoiceUnderlineStyle}
                                    className=" flex-grow-1"
                                >
                                    {invoice.customer.name ?? ''}
                                </div>
                            </div>
                            <div className="col-md-6 d-flex">
                                <div
                                    className="me-2 f-12b"
                                    style={{ minWidth: '130px' }}
                                >
                                    <strong>Date:</strong>
                                </div>
                                <div style={invoiceUnderlineStyle}>
                                    {defaultFormat(invoice.invoice_date)}
                                </div>
                            </div>
                        </div>
                        <div className="d-flex justify-content-between mb-1">
                            <div className="col-md-6 d-flex">
                                <div
                                    className="me-2 f-12b"
                                    style={{ minWidth: '110px' }}
                                >
                                    <strong>TIN:</strong>
                                </div>
                                <div
                                    style={invoiceUnderlineStyle}
                                    className=" flex-grow-1"
                                >
                                    {invoice.customer.tin ?? ''}
                                </div>
                            </div>
                            <div className="col-md-6 d-flex">
                                <div
                                    className="me-2 f-12b"
                                    style={{ minWidth: '130px' }}
                                >
                                    <strong>Terms:</strong>
                                </div>
                                <div style={invoiceUnderlineStyle}>
                                    {invoice.payment_terms.label ?? ''}
                                </div>
                            </div>
                        </div>
                        <div className="d-flex justify-content-between mb-1">
                            <div className="col-md-6 d-flex">
                                <div
                                    className="me-2 f-12b"
                                    style={{ minWidth: '110px' }}
                                >
                                    <strong>Address:</strong>
                                </div>
                                <div
                                    style={invoiceUnderlineStyle}
                                    className=" flex-grow-1"
                                >
                                    {customerAddress ?? ''}
                                </div>
                            </div>
                            <div className="col-md-6 d-flex">
                                <div
                                    className="me-2 f-12b"
                                    style={{ minWidth: '130px' }}
                                >
                                    <strong>OSCA/PWD ID No.:</strong>
                                </div>
                                <div style={invoiceUnderlineStyle}></div>
                            </div>
                        </div>
                        <div className="d-flex justify-content-between mb-1">
                            <div className="col-md-6 d-flex">
                                <div
                                    className="me-2 f-12b"
                                    style={{ minWidth: '110px' }}
                                >
                                    <strong>Business Style:</strong>
                                </div>
                                <div
                                    style={invoiceUnderlineStyle}
                                    className=" flex-grow-1"
                                ></div>
                            </div>
                            <div className="col-md-6 d-flex">
                                <div
                                    className="me-2 f-12b"
                                    style={{ minWidth: '130px' }}
                                >
                                    <strong>Cardholder’s:</strong>
                                </div>
                                <div style={invoiceUnderlineStyle}></div>
                            </div>
                        </div>

                        <div className="d-flex justify-content-between mb-1">
                            <div className="col-md-6 d-flex">
                                <div
                                    className="me-2 f-12b"
                                    style={{ minWidth: '110px' }}
                                ></div>
                                <div className="flex-grow-1"></div>
                            </div>
                            <div className="col-md-6 d-flex">
                                <div
                                    className="me-2 f-12b"
                                    style={{ minWidth: '130px' }}
                                >
                                    <strong>Signature:</strong>
                                </div>
                                <div style={invoiceUnderlineStyle}></div>
                            </div>
                        </div>
                    </div>

                    {/* invoice items table*/}
                    <table
                        className="table-with-border"
                        style={{ width: '100%', marginTop: '10px' }}
                    >
                        {invoice.status === 'draft' && (
                            <div className="watermark">DRAFT</div>
                        )}
                        <thead style={{ textAlign: 'left' }}>
                            <tr style={{ fontWeight: 'bold' }}>
                                <th style={{ padding: '5px' }}>QTY</th>
                                <th style={{ padding: '5px' }}>UNIT</th>
                                <th style={{ padding: '5px' }}>ARTICLE</th>
                                <th style={{ padding: '5px' }}>UNIT PRICE</th>
                                <th style={{ padding: '5px' }}>AMOUNT</th>
                            </tr>
                        </thead>

                        <tbody>
                            {invoice.invoice_items.map((item, index) => {
                                return (
                                    <tr key={index}>
                                        <td
                                            width={'10%'}
                                            style={itemValueStyle}
                                        >
                                            {item.qty}
                                        </td>
                                        <td
                                            width={'10%'}
                                            style={itemValueStyle}
                                        >
                                            {item.product_unit_name
                                                ? item.product_unit_name
                                                : ''}
                                        </td>

                                        <td
                                            width={'60%'}
                                            style={itemProductNameStyle}
                                        >
                                            {item.product_name}
                                            {item.product ? (
                                                <>
                                                    <br />
                                                    <span
                                                        style={{
                                                            fontSize: '9px',
                                                        }}
                                                    >
                                                        {
                                                            item.product
                                                                .description
                                                        }
                                                    </span>
                                                </>
                                            ) : (
                                                ''
                                            )}

                                            {item.brand ? (
                                                <>
                                                    <br />
                                                    <span
                                                        style={{
                                                            fontSize: '9px',
                                                        }}
                                                    >
                                                        {item.brand}
                                                    </span>
                                                </>
                                            ) : (
                                                ''
                                            )}
                                        </td>
                                        <td style={itemValueStyle}>
                                            {item.unit_price}
                                        </td>

                                        <td style={itemValueStyle}>
                                            {item.amount}
                                        </td>
                                    </tr>
                                );
                            })}

                            {invoice.invoice_items.length < 5
                                ? this.renderExtrRow(
                                      5 - invoice.invoice_items.length
                                  )
                                : ''}

                            {/* Summary rows */}
                            <tr>
                                <td
                                    colSpan={2}
                                    className="f-12b"
                                    style={{ textAlign: 'right' }}
                                >
                                    Vatable Sales:&nbsp;
                                </td>
                                <td></td>
                            </tr>
                            <tr>
                                <td
                                    colSpan={2}
                                    className="f-12b"
                                    style={{ textAlign: 'right' }}
                                >
                                    VAT-Exempt Sales:&nbsp;
                                </td>
                                <td>{invoice.vat_exempt_sales}</td>{' '}
                                <td
                                    className="f-12b"
                                    style={{ textAlign: 'right' }}
                                >
                                    Less VAT:&nbsp;
                                </td>
                                <td></td>
                            </tr>
                            <tr>
                                <td
                                    colSpan={2}
                                    className="f-12b"
                                    style={{ textAlign: 'right' }}
                                >
                                    Zero Rated Sales:&nbsp;
                                </td>
                                <td></td>
                                <td
                                    className="f-12b"
                                    style={{ textAlign: 'right' }}
                                >
                                    Amount: Net of VAT:&nbsp;
                                </td>
                                <td></td>
                            </tr>
                            <tr>
                                <td
                                    colSpan={2}
                                    className="f-12b"
                                    style={{ textAlign: 'right' }}
                                >
                                    VAT Amount:&nbsp;
                                </td>{' '}
                                <td>{invoice.tax ?? ''}</td>
                                <td
                                    className="f-12b"
                                    style={{ textAlign: 'right' }}
                                >
                                    Less: SC/PWD Discount:&nbsp;
                                </td>
                                <td></td>
                            </tr>
                            <tr>
                                <td
                                    colSpan={2}
                                    className="f-12b"
                                    style={{ textAlign: 'right' }}
                                >
                                    Total Sales (VAT&nbsp;
                                    {invoice.tax_type
                                        ? invoice.tax_type.label
                                        : ''}
                                    ):&nbsp;
                                </td>{' '}
                                <td>{invoice.total}</td>
                                <td
                                    className="f-12b"
                                    style={{ textAlign: 'right' }}
                                >
                                    Amount:&nbsp;
                                </td>
                                <td></td>
                            </tr>
                            <tr>
                                <td
                                    colSpan={2}
                                    className="f-12b"
                                    style={{ textAlign: 'right' }}
                                >
                                    Less Withholding Tax:&nbsp;
                                </td>{' '}
                                <td>{invoice.tax ?? ''}</td>
                                <td
                                    className="f-12b"
                                    style={{ textAlign: 'right' }}
                                >
                                    Add VAT:&nbsp;
                                </td>
                                <td></td>
                            </tr>
                            <tr>
                                <td
                                    colSpan={4}
                                    className="f-12b "
                                    style={{ textAlign: 'right' }}
                                >
                                    TOTAL AMOUNT DUE:&nbsp;
                                </td>
                                <td>{invoice.total}</td>
                            </tr>
                        </tbody>
                    </table>
                    {/* end of invoice items table */}

                    <div>
                        <div className="col-12  f-10 text-right">
                            Received the above items in good order and condition
                        </div>
                    </div>
                    <div className="mt-5">
                        <div className="col-12  f-10 text-right ">
                            <div>_____________________________________</div>{' '}
                            <div style={{ marginRight: '50px' }}>
                                Customer's Signature
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12 pb-0 mb-0">
                        <span className="pull-right f-12">
                            Page {page}/{totalPage}
                        </span>
                    </div>
                </div>
            </div>
        );
    }

    renderMultiplePage() {
        const tableRows = [];
        const tableRowsTry = [];
        let numberOfPage = Math.ceil(
            this.state.totalItemsCount / this.state.itemsCountPerPage
        );
        for (let i = 1; i <= numberOfPage; i++) {
            tableRows.push(this.renderPrint(i, Math.floor(numberOfPage)));
        }
        return tableRows;
    }

    render() {
        let invoice = this.state.invoice;

        let numberOfPage = Math.ceil(
            this.state.totalItemsCount / this.state.itemsCountPerPage
        );

        return (
            <Fragment>
                {/*
                <div className="temp-watermark">
                    <h1>{invoice.status == 'draft' ? invoice.status : ''}</h1>
                </div>
            */}
                <div ref={this.divScrollRef} className="main-print-div">
                    {this.state.print == 0 ? (
                        this.renderPrint(this.state.activePage, numberOfPage)
                    ) : (
                        <Fragment>{this.renderMultiplePage()}</Fragment>
                    )}{' '}
                </div>

                <div className="hidden-print d-flex justify-content-center pagination-print">
                    <Pagination
                        className="pagination"
                        itemclassName="page-item"
                        linkclassName="page-link"
                        activePage={this.state.activePage}
                        itemsCountPerPage={this.state.itemsCountPerPage}
                        totalItemsCount={this.state.totalItemsCount}
                        pageRangeDisplayed={this.state.pageRangeDisplayed}
                        onChange={this.handlePageChange.bind(this)}
                    />
                </div>
            </Fragment>
        );
    }
}

export default ChargedSalesInvoice;
